<template>
  <div class="h-screen">
    <div id="gjs" />
  </div>
</template>

<script>
import 'grapesjs/dist/css/grapes.min.css';
import grapesjs from 'grapesjs';
import 'grapesjs-preset-webpage';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  mounted() {
    const ckeditorScript = document.createElement('script');
    ckeditorScript.setAttribute('src', 'https://cdn.ckeditor.com/4.16.1/full-all/ckeditor.js');
    const vm = this;
    ckeditorScript.onload = () => {
      vm.editor = grapesjs.init({
        container: '#gjs',
        fromElement: false,
        height: '100%',
        width: 'auto',
        storageManager: false,
        plugins: ['gjs-preset-webpage'],
        pluginsOpts: {
          'gjs-preset-webpage': {
            customStyleManager: [
              {
                name: 'Flex',
                open: false,
                properties: [
                  {
                    name: 'Flex Container',
                    property: 'display',
                    type: 'select',
                    defaults: 'block',
                    list: [
                      { value: 'block', name: 'Disable' },
                      { value: 'flex', name: 'Enable' },
                    ],
                  },
                  {
                    name: 'Flex Parent',
                    property: 'label-parent-flex',
                    type: 'integer',
                  },
                  {
                    name: 'Direction',
                    property: 'flex-direction',
                    type: 'radio',
                    defaults: 'row',
                    list: [
                      {
                        value: 'row',
                        name: 'Row',
                        className: 'icons-flex icon-dir-row',
                        title: 'Row',
                      },
                      {
                        value: 'row-reverse',
                        name: 'Row reverse',
                        className: 'icons-flex icon-dir-row-rev',
                        title: 'Row reverse',
                      },
                      {
                        value: 'column',
                        name: 'Column',
                        title: 'Column',
                        className: 'icons-flex icon-dir-col',
                      },
                      {
                        value: 'column-reverse',
                        name: 'Column reverse',
                        title: 'Column reverse',
                        className: 'icons-flex icon-dir-col-rev',
                      },
                    ],
                  },
                  {
                    name: 'Justify',
                    property: 'justify-content',
                    type: 'radio',
                    defaults: 'flex-start',
                    list: [
                      {
                        value: 'flex-start',
                        className: 'icons-flex icon-just-start',
                        title: 'Start',
                      },
                      {
                        value: 'flex-end',
                        title: 'End',
                        className: 'icons-flex icon-just-end',
                      },
                      {
                        value: 'space-between',
                        title: 'Space between',
                        className: 'icons-flex icon-just-sp-bet',
                      },
                      {
                        value: 'space-around',
                        title: 'Space around',
                        className: 'icons-flex icon-just-sp-ar',
                      },
                      {
                        value: 'center',
                        title: 'Center',
                        className: 'icons-flex icon-just-sp-cent',
                      },
                    ],
                  },
                  {
                    name: 'Align',
                    property: 'align-items',
                    type: 'radio',
                    defaults: 'center',
                    list: [
                      {
                        value: 'flex-start',
                        title: 'Start',
                        className: 'icons-flex icon-al-start',
                      },
                      {
                        value: 'flex-end',
                        title: 'End',
                        className: 'icons-flex icon-al-end',
                      },
                      {
                        value: 'stretch',
                        title: 'Stretch',
                        className: 'icons-flex icon-al-str',
                      },
                      {
                        value: 'center',
                        title: 'Center',
                        className: 'icons-flex icon-al-center',
                      },
                    ],
                  },
                  {
                    name: 'Flex Children',
                    property: 'label-parent-flex',
                    type: 'integer',
                  },
                  {
                    name: 'Order',
                    property: 'order',
                    type: 'integer',
                    defaults: 0,
                    min: 0,
                  },
                  {
                    name: 'Flex',
                    property: 'flex',
                    type: 'composite',
                    properties: [
                      {
                        name: 'Grow',
                        property: 'flex-grow',
                        type: 'integer',
                        defaults: 0,
                        min: 0,
                      },
                      {
                        name: 'Shrink',
                        property: 'flex-shrink',
                        type: 'integer',
                        defaults: 0,
                        min: 0,
                      },
                      {
                        name: 'Basis',
                        property: 'flex-basis',
                        type: 'integer',
                        units: ['px', '%', ''],
                        unit: '',
                        defaults: 'auto',
                      },
                    ],
                  },
                  {
                    name: 'Align',
                    property: 'align-self',
                    type: 'radio',
                    defaults: 'auto',
                    list: [
                      {
                        value: 'auto',
                        name: 'Auto',
                      },
                      {
                        value: 'flex-start',
                        title: 'Start',
                        className: 'icons-flex icon-al-start',
                      },
                      {
                        value: 'flex-end',
                        title: 'End',
                        className: 'icons-flex icon-al-end',
                      },
                      {
                        value: 'stretch',
                        title: 'Stretch',
                        className: 'icons-flex icon-al-str',
                      },
                      {
                        value: 'center',
                        title: 'Center',
                        className: 'icons-flex icon-al-center',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
      });

      function toHtml(opts) {
        return this.getInnerHTML(opts);
      }

      vm.editor.getWrapper().toHTML = toHtml;

      vm.addEditButton();
      vm.addSaveAndExitButton();

      vm.editor.on('change', vm.change);
    };

    document.head.appendChild(ckeditorScript);
  },
  methods: {
    change() {
      this.$emit('change', this.editor.getHtml());
    },
    addSaveAndExitButton() {
      const vm = this;
      this.editor.Panels.addButton('options', [
        {
          id: 'save',
          className: 'fa fa-floppy-o icon-blank',
          // eslint-disable-next-line no-alert
          command(/** editor, sender */) {
            alert('Todo');
          },
          attributes: { title: 'Save Template' },
        },
        {
          id: 'exit',
          className: 'fa fa-sign-out icon-blank',
          command(/** editor, sender */) {
            vm.$router.replace({
              name: 'accounts.show',
              params: {
                accountId: vm.accountId,
              },
            });
          },
          attributes: { title: 'Exit' },
        },
      ]);
    },
    addEditButton() {
      const prefix = this.editor.getConfig().stylePrefix;
      const modal = this.editor.Modal;
      const commands = this.editor.Commands;
      const codeViewer = this.editor.CodeManager.getViewer('CodeMirror').clone();
      const panels = this.editor.Panels;
      const container = document.createElement('div');
      const button = document.createElement('button');

      codeViewer.set({
        codeName: 'htmlmixed',
        readOnly: 0,
        theme: 'hopscotch',
        autoBeautify: true,
        autoCloseTags: true,
        autoCloseBrackets: true,
        lineWrapping: true,
        styleActiveLine: true,
        smartIndent: true,
        indentWithTabs: true,
      });

      button.innerHTML = 'Edit';
      button.className = `${prefix}btn-prim ${prefix}btn-import`;

      button.onclick = () => {
        const code = codeViewer.editor.getValue();
        this.editor.DomComponents.getWrapper().set('content', '');
        this.editor.setComponents(code.trim());
        modal.close();
      };

      commands.add('html-edit', {
        run(editor, sender) {
          if (sender) {
            sender.set('active', 0);
          }

          let viewer = codeViewer.editor;
          modal.setTitle('Edit code');
          if (!viewer) {
            const txtarea = document.createElement('textarea');
            container.appendChild(txtarea);
            container.appendChild(button);
            codeViewer.init(txtarea);
            viewer = codeViewer.editor;
          }

          const InnerHtml = editor.getHtml();
          const Css = editor.getCss();
          modal.setContent('');
          modal.setContent(container);
          codeViewer.setContent(`${InnerHtml}<style>${Css}</style>`);
          modal.open();
          viewer.refresh();
        },
      });

      panels.addButton('options', [
        {
          id: 'edit',
          className: 'fa fa-edit',
          command: 'html-edit',
          attributes: {
            title: 'Edit',
          },
        },
      ]);
    },
  },
};
</script>
